import { vmodule, VueModule } from '@niknevis/vue-modules'
import HTTP from './services/http.service'

declare module 'vue/types/vue' {
  interface Vue {
    HTTP: HTTP
  }
}

@vmodule()
export default class HttpModule extends VueModule {
  readonly name = 'HttpModule'

  services = {
    HTTP
  }
}
